import { createFileRoute } from '@tanstack/react-router'
import { InitiativeWorkspace } from '../features/prd'

function Initiative() {
  const { workspaceId, initiativeId } = Route.useParams()
  const navigate = Route.useNavigate()
  return (
    <InitiativeWorkspace
      workspaceId={workspaceId}
      initiativeId={initiativeId}
      onOpenConversation={(conversationId) => {
        void navigate({
          to: '/w/$workspaceId/conversations/$conversationId',
          params: { workspaceId, conversationId },
        })
      }}
    />
  )
}

export const Route = createFileRoute('/w/$workspaceId/initiatives/$initiativeId')({
  component: Initiative,
})
